/* @flow */
import { Validation, ValidationError } from "./lib/validation";

class AppValidation extends Validation {
  // That's how we can add custom validations.
}

const validate = data => new AppValidation(data);

export default validate;



/** WEBPACK FOOTER **
 ** ./src/common/validate.js
 **/